import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "@/store/AuthContext";
import { ErrorProvider, useError } from "@/store/ErrorContext";
// import { SocketProvider } from "@/store/SocketContext";
import { AppContent } from "@/routes/AppRoutes";
import useFcmToken from "@/hooks/useFcmToken";
import { usePwaInstall } from "@/hooks/usePwaInstall";
import { useOfflineDetection } from "@/hooks/useOfflineDetection";
import { setGlobalErrorHandler } from "@/api/apiClient";
import GlobalErrorScreen from "@/components/GlobalErrorScreen";
import InstallPrompt from "@/components/InstallPrompt";
import { useEffect } from "react";

const queryClient = new QueryClient();

const NotificationHandler = () => {
  useFcmToken();
  return null;
};

const AppWrapper = () => {
  const { hasError, setGlobalError } = useError();
  const { show, install, decline } = usePwaInstall();

  // Set up offline detection
  useOfflineDetection();

  // Set up global error handler for API client
  useEffect(() => {
    setGlobalErrorHandler(setGlobalError);
  }, [setGlobalError]);

  // If there's a global error, show the error screen
  if (hasError) {
    return <GlobalErrorScreen />;
  }

  return (
    <>
      {show && <InstallPrompt onInstall={install} onCancel={decline} />}
      <NotificationHandler />
      <AppContent />
    </>
  );
};

const App = () => (
  <QueryClientProvider client={queryClient}>
    <ErrorProvider>
      <AuthProvider>
        {/* <SocketProvider> */}
        <BrowserRouter>
          <AppWrapper />
        </BrowserRouter>
        {/* </SocketProvider> */}
      </AuthProvider>
    </ErrorProvider>
  </QueryClientProvider>
);

export default App;
